import { render } from "./VerticalBreak.vue?vue&type=template&id=5f8af90e&scoped=true"
import script from "./VerticalBreak.vue?vue&type=script&lang=js"
export * from "./VerticalBreak.vue?vue&type=script&lang=js"

import "./VerticalBreak.vue?vue&type=style&index=0&id=5f8af90e&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8af90e"]])

export default __exports__